<header class="page-header">
  <svg class="header-border header-border--sp" viewBox="0 0 375 6" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M0 0H121.5L111.908 6H0V0Z" fill="#1758A7" />
    <path d="M92.9894 0H206L200.522 6H84.5L92.9894 0Z" fill="#002F7B" />
    <path d="M172.508 0H283.983L290.5 6H169L172.508 0Z" fill="#1746FF" />
    <path d="M375 0H253.5L262.048 6H375V0Z" fill="#38BEEF" />
  </svg>
  <img class="header-border header-border--pc" ngSrc="/page-header/header-border-pc.svg" width="1440" height="16" alt="" aria-hidden="true" priority />
  <div class="header-contents">
    <div class="header-logo-container">
      <button type="button" class="logo-btn" aria-label="オフィシャルHPを開く" (click)="openOfficialSite()">
        <img class="header-logo" ngSrc="/page-header/logo.svg" width="142" height="44" alt="第一生命" priority />
      </button>
    </div>
    @if (showActions()) {
      <div class="header-actions">
        @if (!isMenuOpen()) {
          <a class="header-link" href="#" (click)="openGlossary($event)">
            <img class="header-link__icon" ngSrc="/page-header/info.svg" width="16" height="16" alt="" aria-hidden="true" />
            用語解説
          </a>
        }
        <button type="button" class="header-link header-faq" (click)="openFaq()" aria-label="よくある質問を開く">
          <img class="header-link__icon" ngSrc="/page-header/link.svg" width="16" height="16" alt="" aria-hidden="true" />
          {{ masterDataStore.getDisplayTitle(UrlConstants.FAQ_URL) }}
        </button>
        <button type="button" class="header-link header-close" (click)="closeWindow()">
          <img class="header-link__icon header-link__icon--close" ngSrc="/page-header/close.svg" width="17" height="17" alt="" aria-hidden="true" />
          ウィンドウを閉じる
        </button>
        <button type="button" class="header-menu" [attr.aria-label]="isMenuOpen() ? 'メニューを閉じる' : 'メニューを開く'" [attr.aria-expanded]="isMenuOpen()" (click)="onMenuButtonClick()">
          @if (isMenuOpen()) {
            <i class="fa-solid fa-xmark"></i>
          } @else {
            <i class="fa-solid fa-bars"></i>
          }
        </button>
      </div>
    }
  </div>
</header>
<app-glossary-modal [isOpen]="glossaryOpen()" (closed)="closeGlossary()"></app-glossary-modal>
